export default "﻿<div data-bind=\"control: { uiGenerator: 'MessageBox', viewModel: viewModel }\">\r\n\r\n</div>\r\n"